import React from 'react';

import { Icon } from '@components/atoms';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { DatePicker as ADatePicker, DatePickerProps } from 'antd';
import { RangePickerDateProps } from 'antd/lib/date-picker/generatePicker';

const { RangePicker: ARangePicker } = ADatePicker;

export type TDatePickerParams = DatePickerProps & {
  fullWidth?: boolean;
};

export type TDateRangePickerParams = RangePickerDateProps<any> & {
  fullWidth?: boolean;
};

const isPropValid = (props: any) => props !== 'fullWidth';

const StyledDatePicker = styled(ADatePicker, { shouldForwardProp: isPropValid })<TDatePickerParams>`
  height: 36px !important;
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
  ${({ disabled, theme }) =>
    disabled &&
    css`
      svg path,
      svg g {
        stroke: ${theme.gray5} !important;
      }
    `}
`;

export const DatePicker = ({ ...rest }: TDatePickerParams) => (
  <StyledDatePicker suffixIcon={<Icon icon="icoCalendar" />} {...rest} />
);

const StyledDateRangePicker = styled(ARangePicker, {
  shouldForwardProp: isPropValid,
})<TDateRangePickerParams>`
  height: 36px !important;
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
  ${({ disabled, theme }) =>
    disabled &&
    css`
      svg path,
      svg g {
        stroke: ${theme.gray5} !important;
      }
      input::placeholder {
        color: ${theme.gray4} !important;
      }
    `}
  .ant-picker-range-separator {
    top: -7px !important;
    position: relative !important;
  }
  .anticon.anticon-swap-right {
    display: none;
  }
  .ant-picker-range-separator:after {
    content: '~';
    font-size: 16px;
    color: ${({ theme }) => theme.gray5} !important;
    ${({ disabled, theme }) =>
      disabled &&
      css`
        color: ${theme.gray4} !important;
      `}
    padding-left: 3px;
  }
`;

export const DateRangePicker = ({ ...rest }: TDateRangePickerParams) => (
  <StyledDateRangePicker suffixIcon={<Icon icon="icoCalendar" />} {...rest} />
);
